export default function() {
    return {
        init: function() {
            this.backToTop();
            this.mobileNav();
            this.fileUploadBtn();
        },
        fileUploadBtn: function() {
            var wrapper = $('.file_upload');
            var inp = wrapper.find('input');
            var btn = wrapper.find('.button');
            var lbl = wrapper.find('mark');

            inp.focus(function() {
                wrapper.addClass('focus');
            }).blur(function() {
                wrapper.removeClass('focus');
            });

            var file_api = (window.File && window.FileReader && window.FileList && window.Blob) ? true : false;

            inp.change(function() {
                var file_name;
                if (file_api && inp[ 0 ].files[ 0 ]) {
                    file_name = inp[ 0 ].files[ 0 ].name;
                } else {
                    file_name = inp.val().replace('C:fakepath', '');
                }

                if (!file_name.length) {
                    return;
                }

                if (lbl.is(':visible')) {
                    lbl.text(file_name);
                    btn.text('Выбрать');
                } else {
                    btn.text(file_name);
                }
            }).change();

            $(window).resize(function() {
                $('.file_upload input').triggerHandler('change');
            });
        },
        mobileNav: function() {
            var window_w = $(window).width(); // Window Width
            var window_h = $(window).height(); // Window Height
            var window_s = $(window).scrollTop(); // Window Scroll Top

            /* Menu Button */
            $('.mobile-menu').click(function() {
                if (!$('.main-menu').hasClass('main-menu--opened')) {
                    $('.main-menu').slideDown(500).addClass('main-menu--opened');
                } else {
                    $('.main-menu').slideUp(500).removeClass('main-menu--opened');
                }
            });

            /* On Resize */
            $(window).resize(function() {
                if (window_w > 991) {
                    $('.main-menu').show().attr('style', '').removeClass('main-menu--opened');
                }
            });

            /* Dropdowns */
            $('.main-menu li').each(function() {
                if ($(this).find('ul').length > 0) {
                    $(this).append('<div class="dropdown-button"></div>');
                }
            });

            $('.main-menu .dropdown-button').click(function() {
                $(this).parent().toggleClass('dropdown-opened').find('>ul').slideToggle(300);
            });

        },
        backToTop: function() {
            var window_w = $(window).width(); // Window Width
            var window_h = $(window).height(); // Window Height
            var window_s = $(window).scrollTop(); // Window Scroll Top

            $('.button-to-top').hide();

            /* Show/Hide button */
            $(window).scroll(function() {
                if (window_s > 100 && window_w > 991) {
                    $('.button-to-top').fadeIn(300);
                } else {
                    $('.button-to-top').fadeOut(300);
                }
            });

            $('.button-to-top').click(function(e) {
                $('body,html').animate({ scrollTop: 0 }, 600);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./frontend/src/js/modules/main.js